export const getSeekHeaders = (options) => {
    if ('zone' in options) {
        return { 'seek-request-zone': options.zone };
    }
    return Object.assign({ 'seek-request-brand': options.brand }, (options.country && { 'seek-request-country': options.country }));
};
//# sourceMappingURL=getSeekHeaders.js.map